// firebaseConfig.js
import { initializeApp } from "firebase/app";
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
  signOut,
  onAuthStateChanged,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Replace with your Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyBCZDrQOBi_SMmWIeCgkBOAvpNSzkD6h6A",
  authDomain: "skyholistics-1366c.firebaseapp.com",
  projectId: "skyholistics-1366c",
  storageBucket: "skyholistics-1366c.appspot.com",
  messagingSenderId: "299960912418",
  appId: "1:299960912418:web:3e31ce5e42ca2d52ef587b",
  measurementId: "G-61ED6NFTTE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const googleProvider = new GoogleAuthProvider();

// Export the auth services
export {
  auth,
  db,
  googleProvider,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signInWithPopup,
  signOut,
  onAuthStateChanged,
};
